const messages = {
  title: `USAIL<sup>scRNA</sup>`,
  content: 'A user-centric, scalable and interactive cloud-based web server for large-scale single-cell RNA-seq data analysis. It helps researchers focus on biological intuition rather than on mathematical and algorithmic foundations.'
}

export default messages
